// 负责处理排序相关逻辑
import { get } from "lodash";
import { ColumnType, ITypeOptions } from "../types/table-type";
import { compareByColumn } from "./compareByColumn";
import { getCollaborators, IReduxUser } from "./tableData_secondary";

/** 对于有些列类型 item 期望是 array 多选 关联 成员 创建者 */
const ITEM_IS_ARR_BY_COLUMN_TYPE = [
  ColumnType.MULTI_SELECT,
  ColumnType.RECORD_REFERENCE,
  ColumnType.COLLABORATOR,
  ColumnType.CREATED_BY,
];

/** TODO: 这个东西是不是应该移动到更高层级 */
type IItem = { [key in string]: string | number };

/**
 * 基于 compareByColumn 保证的通用排序函数 因为后面 会迁移到 common-logic 所以最好在这里包一层
 * valueKey 用于从 item 中取出用于比较的值 如果没有 valueKey 则直接使用 item 比较
 */
export const basicSortFunc = ({
  columType,
  columnOptions,
  valueKey,
}: {
  columType: ColumnType;
  columnOptions: ITypeOptions;
  valueKey: string;
}): ((item1: IItem, item2: IItem) => number) => {
  const { collaboratorsById } = getCollaborators();
  const getCollaboratorById = (groupId: string) => collaboratorsById[groupId] as IReduxUser;

  const func = (item1: IItem, item2: IItem) => {
    const itemIsArr = ITEM_IS_ARR_BY_COLUMN_TYPE.includes(columType);
    const value1 = itemIsArr ? [get(item1, valueKey)] : get(item1, valueKey);
    const value2 = itemIsArr ? [get(item2, valueKey)] : get(item2, valueKey);
    return compareByColumn(getCollaboratorById, columType, columnOptions, value1, value2);
  };

  return func;
};
